import AuthorizationsService from "../../services/authorizations/AuthorizationsService";
import dayjs from "dayjs";
const isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
const isSameOrAfter = require("dayjs/plugin/isSameOrAfter");

import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      medicinesData: [],
      checkedRows: [],
      orderDetails: [],
      slidingScaleFee: 0,
      shippingFee: 0,
      providers: [],
      patient: null,
      name: "",
      importations: [],
      idPatient: null,
      date: "",
      data: [],
      fecha: [],
      searchString: "",
      isLoading: false,
      isFullPage: true,
      datesFilter: [],
      monthNames: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      dayNames: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
      showNoFilterResults: false,
      initialDate: null,
      finalDate: null
    };
  },

  async created() {
    await this.getAppOrderPatient();
    this.isLoading = false;
    dayjs.extend(isSameOrBefore);
    dayjs.extend(isSameOrAfter);
  },

  computed: {
    ...mapState("auth", ["user", "identification"]),

    ...mapGetters("auth", {
      isAuthenticated: "isAuthenticated"
    })
  },

  methods: {
    clearDatePicker() {
      this.datesFilter = [];
      this.initialDate = null;
      this.finalDate = null;
    },

    async clearHistory() {
      this.datesFilter = [];
      this.searchString = "";
      this.initialDate = null;
      this.finalDate = null;
      this.filterHistory();
    },

    async filterHistory() {
      this.searchString = this.searchString.toLowerCase();
      if (this.initialDate !== null || this.finalDate !== null) {
        if (this.initialDate !== null && this.finalDate !== null) {
          let initialDate = dayjs(this.initialDate);
          let finalDate = dayjs(this.finalDate);
          if (finalDate.isAfter(initialDate)) {
            if (this.searchString.length > 0) {
              for (let index = 0; index < this.data.length; index++) {
                const order = this.data[index];
                this.data[index].show = false;
                let generationDate = dayjs(order.generationDate);
                let dateBetween =
                  generationDate.isSameOrAfter(initialDate) &&
                  generationDate.isSameOrBefore(finalDate);
                if (dateBetween) {
                  if (order.id.toString().includes(this.searchString)) {
                    this.data[index].show = true;
                    continue;
                  }
                  for (let i = 0; i < order.authorizations.length; i++) {
                    if (
                      order.authorizations[i]
                        .toLowerCase()
                        .includes(this.searchString)
                    ) {
                      this.data[index].show = true;
                      break;
                    }
                  }
                  if (!this.data[index].show) {
                    for (let i = 0; i < order.medicines.length; i++) {
                      if (
                        order.medicines[i]
                          .toLowerCase()
                          .includes(this.searchString)
                      ) {
                        this.data[index].show = true;
                        break;
                      }
                    }
                  }
                }
              }
            } else {
              for (let index = 0; index < this.data.length; index++) {
                const order = this.data[index];
                this.data[index].show = false;
                let generationDate = dayjs(order.generationDate);
                let dateBetween =
                  generationDate.isSameOrAfter(initialDate) &&
                  generationDate.isSameOrBefore(finalDate);
                if (dateBetween) {
                  this.data[index].show = true;
                }
              }
            }
          } else {
            this.$buefy.toast.open({
              message: "La fecha final debe ser mayor a la inicial",
              type: "is-danger"
            });
          }
        } else {
          this.$buefy.toast.open({
            message:
              "Si deseas usar el filtro por fecha debes seleccionar una fecha inicial y una final",
            type: "is-danger"
          });
        }
      } else if (this.searchString.length > 0) {
        for (let index = 0; index < this.data.length; index++) {
          const order = this.data[index];
          this.data[index].show = false;
          if (order.id.toString().includes(this.searchString)) {
            this.data[index].show = true;
            continue;
          }
          for (let i = 0; i < order.authorizations.length; i++) {
            if (
              order.authorizations[i].toLowerCase().includes(this.searchString)
            ) {
              this.data[index].show = true;
              break;
            }
          }
          if (!this.data[index].show) {
            for (let i = 0; i < order.medicines.length; i++) {
              if (
                order.medicines[i].toLowerCase().includes(this.searchString)
              ) {
                this.data[index].show = true;
                break;
              }
            }
          }
        }
      } else {
        this.data.forEach((order, index) => {
          this.data[index].show = true;
        });
      }

      let anyFiltered = this.data.filter(order => {
        return order.show === true;
      });
      this.showNoFilterResults = anyFiltered.length > 0 ? false : true;
      this.$forceUpdate();
    },

    async getAppOrderPatient() {
      this.isLoading = true;

      const response = await AuthorizationsService.getAppOrderPatient(
        this.identification
      );
      this.data = response.data;
      this.data = this.data.sort(
        (a, b) =>
          new Date(b.generationDate).getTime() -
          new Date(a.generationDate).getTime()
      );

      this.data.forEach(orderItem => {
        orderItem.show = true;
        let generationDateFormatter = new Date(orderItem.generationDate);
        orderItem.generationDate = dayjs(generationDateFormatter).format(
          "YYYY-MM-DD"
        );

        orderItem.tooltip = "";

        switch (orderItem.status) {
          case "CANCELED":
            orderItem.status = "Cancelado";
            orderItem.statusFixed = "Cancelado";
            orderItem.tooltip =
              "Tu pedido no puede ser entregado. Tu pedido ha sido cancelado ";
            break;
          case "CHECKED_OUT":
            orderItem.status = "Distribución";
            orderItem.statusFixed = "Distribución";
            orderItem.tooltip =
              "Tu pedido se ha enviado para ser entregado en el domicilio.";
            break;
          case "DELIVERED":
            orderItem.status = "Entregado";
            orderItem.statusFixed = "Entregado";
            orderItem.tooltip = "Tu pedido ha sido entregado";
            break;
          case "SCHEDULED":
            orderItem.status = "Agendado";
            orderItem.statusFixed = "Agendado";
            orderItem.tooltip = "Tu pedido ha sido registrado con éxito";
            break;
          case "PARTIALLY_CHECKED_IN":
            orderItem.status = "Empacado";
            orderItem.statusFixed = "Empacado";
            orderItem.tooltip =
              "Tu pedido está siendo preparado para realizar el envío.";
            break;
          case "CHECKED_IN":
            orderItem.status = "Empacado";
            orderItem.statusFixed = "Empacado";
            orderItem.tooltip =
              "Tu pedido está siendo preparado para realizar el envío.";
            break;
          case "CLOSURE_IN_PROGRESS":
            orderItem.status = "Entregado";
            orderItem.statusFixed = "Entregado";
            orderItem.tooltip = "Tu pedido ha sido entregado";
            break;
          case "RETURNED":
            orderItem.status = "Devuelto";
            orderItem.statusFixed = "Devuelto";
            orderItem.tooltip =
              "Tu pedido no pudo ser entregado. Tu pedido ha sido devuelto";
            break;
          default:
            break;
        }
        let realDateText = "";
        if (orderItem.realDate) {
          let dateToShow = new Date(orderItem.realDate);
          realDateText = ` el ${dayjs(dateToShow).format("YYYY-MM-DD")}`;
        }
        orderItem.status = orderItem.status + realDateText;
        // let dataTable = []
        let authorizations = [];
        let medicines = [];
        orderItem.orderDetails.forEach(od => {
          authorizations.push(od.code);
          // let dataMedicines = []
          od.orderDetailMedicines.forEach(odm => {
            odm.showQuantity =
              orderItem.status === "Empacado" ||
              orderItem.status === "Distribución" ||
              orderItem.status === "Entregado"
                ? odm.deliveredQuantity
                : odm.quantity;
            medicines.push(odm.description);
            // dataMedicines.push({
            //     authorization: '',
            //     description: odm.description,
            //     showQuantity: (orderItem.status === 'Empacado' || orderItem.status === 'Distribución' || orderItem.status === 'Entregado') ? odm.deliveredQuantity : odm.quantity,
            //     pending: odm.quantity - odm.deliveredQuantity,
            //     id: ''
            // })
          });
          // dataTable.push({
          //     authorization: od.code,
          //     description: '',
          //     pending: 0,
          //     items: dataMedicines,
          //     id: orderItem.id,
          //     showQuantity: ''
          // })
        });
        // orderItem.dataTable = dataTable
        orderItem.authorizations = authorizations;
        orderItem.medicines = medicines;
      });
    },
    showOrderDetailQuantity(status) {
      let result = false;
      if (status != "Agendado" && status != "Cancelado") {
        result = true;
      }
      return result;
    },
    showOrderDetailDeliveredQuantity(status) {
      let result = false;
      if (status == "Empacado" || status == "Distribución") {
        result = true;
      }
      return result;
    }
  }
};
